import { render, staticRenderFns } from "./ArchiveSideBar.vue?vue&type=template&id=4bcd9b46&"
import script from "./ArchiveSideBar.vue?vue&type=script&lang=js&"
export * from "./ArchiveSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports